import { createContext } from "react";
import type { IbanXSBanksCountriesPivotContext as IbanXSBanksCountriesPivotContextType } from "./types";

export const initialState: IbanXSBanksCountriesPivotContextType = {
    isLoading: false,
    pivot: null
};

export const IbanXSBanksCountriesPivotContext = createContext<IbanXSBanksCountriesPivotContextType>(initialState);
